
export const constants = {
   apiServer: 'https://admin.boostmymenu.com/api',
   pathImagesIntro: 'https://admin.boostmymenu.com/images/intros',
   pathImagesMenu: 'https://admin.boostmymenu.com/images/menus',  
   pathImagesTags: 'https://admin.boostmymenu.com/images/tags',
   pathIconCategories: 'https://admin.boostmymenu.com/images/categories/icons',  
   pathLogoRestaurant: 'https://admin.boostmymenu.com/images/restaurants/logos',  
}